<template>
    <div class="accept shop-view">
        <div class="accept-view">
            <div class="user-info clearfix">
                <span class="user-name"><em v-if="$store.state.userinfo.areaId">【{{ $queryArea($store.state.userinfo.areaId) }}】</em>{{ $store.state.userinfo.name || $store.state.ua.account || '仙术师' }}</span>
            </div>
            
            <div class="accept-detail">
                <div class="notice success" v-if="acceptinfo.currentDiscount > 0">成功帮砍<em class="icon-m3b"></em>{{ acceptinfo.currentDiscount }}，够兄弟</div>
                <div class="notice err" v-else>{{ error }}</div>

                <div class="goods-detail" v-if="acceptinfo.shopName">
                    <div class="item-panel" v-if="acceptinfo">
                        <div class="shop-banner">{{ acceptinfo.shopName }}</div>
                        <div class="item-detail clearfix">                           
                            <div class="pic f-l"><div class="item-pic"><game-item :id="acceptinfo.itemid" :num="acceptinfo.itemcount" :locked="true"></game-item></div></div>
                            <div class="item-info f-l">
                                <h6 class="item-name">{{ acceptinfo.name }}</h6>
                                <div class="low">最低价<em class="icon-m3b"></em><span>{{ acceptinfo.priceMin }}</span><span class="p-before">{{ acceptinfo.priceBefore }}</span></div>
                                <div class="now">当前价<em class="icon-m3b"></em><span>{{ acceptinfo.priceCurrent }}</span></div>
                            </div>
                            <div class="u-btn apply f-r" v-bind:data-gid="acceptinfo.id" @click="discountStart(acceptinfo.id);"></div>                       
                        </div>                                                     
                    </div>                                
                </div>

                <div class="discount-detail">
                    <div class="title"></div>
                    <ul>
                        <li class="clearfix" v-for="(player,index) in acceptinfo.list" :key="index">
                            <div class="player-name f-l">
                                {{ player.name.replace(/\x7F+/g,"") }}
                                <em class="icon-first" v-if="player.mode == 1"></em>
                                <em class="icon-best" v-if="player.mode == 2"></em>
                            </div>
                            <div class="cnt f-r">
                                <em class="icon-m3b"></em>
                                {{ player.discount }}
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </div>

        <recommend></recommend>

        <div class="bottom-bubble">
            <div class="txt-bubble"></div>
            <div class="u-btn u-top"></div>
        </div>          

    </div>
</template>

<script>
import recommend from '@/components/recommend.vue'

export default {
    components : {
        'recommend' : recommend,
    },      
    data (){
        return {
            key : '',
            acceptinfo : () => {},
            error : '请稍后再试~'
        }
    },
    mounted (){
        //alert(this.$route.params.key)
        if(!parseInt(this.$store.state.login)){
            this.$router.push('/')
            return this.$mslogin.open();
        }
        if(!this.$store.state.userinfo){
            this.$bind_modal();
            return this.$toast('请先选择大区');
        }

        this.key = this.$route.params.key;
        
        if(!this.key){
            this.$router.push('/')
            return this.$toast('商品不存在！');
        }        
        
        this.render();
    },
    methods : {
        render (){
            //if(!this.key)return;
            this.$axios.post(this.$ajax_url_map.acceptShare,this.$qs.stringify({
                key : this.key
            }))
            .then(res => {
                this.acceptinfo = res.data;
                this.$toast('砍价成功~');
                localStorage.setItem('code', '');
            },rej => {
                this.$toast(rej.message);
                this.error = rej.message;
                localStorage.setItem('code', '');
            }) 
        },
        discountStart (gid){
            //TODO
            this.$share_modal({
                gid : gid,
            })
        },        
    },
}
</script>

<style scoped>
/* accept */
.accept {
    width: 100%;
    min-height: 100vh;
    padding-top: 10px;
    background-image: url(~@/assets/images/body-basket.jpg);
    background-size: 750px auto;
    background-repeat: repeat-y;
}

.accept-view {
    width: 750px;
    height: 812px;
    margin: 0 auto;
    padding-top: 82px;
    background-image: url(~@/assets/images/bg-accept.png);
    box-sizing: border-box;
}

.accept-view .user-info {
    padding-left: 30px;
    color: #dcc4b1;
}

.accept-detail {
    margin-top: 12px;
}

.accept-detail .notice {
    margin-bottom: 10px;
    font-size: 28px;
    font-weight: 700;
    color: #d4a161;
    text-align: center;
}

.accept-detail .goods-detail {
    width: 721px;
    height: 243px;
    margin: 0 0 10px 18px;
    background-image: url(~@/assets/images/bg-accept-item.png);
    box-sizing: border-box;
}

.accept-detail .shop-banner {
    margin-bottom: 10px;
    font-size: 28px;
    color: #683d1e;
    font-weight: 700;
    text-align: center;
}

.accept-detail .pic {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 113px;
    height: 112px;
    background-image: url(~@/assets/images/bg-item_2.png);
}

.accept-detail .pic .item-pic {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.accept-detail .goods-detail {
    padding: 25px 30px 0;
}

.accept-detail .item-info {
    margin-left: 15px;
}

.accept-detail .item-name {
    margin: 0 0 5px;
    color: #683d1e;
    font-weight: 700;
    font-size: 24px;
}

.accept-detail .low {
    /* text-align: center; */
    color: #683d1e;
}

.accept-detail .now {
    color: #683d1e;
}

.accept-detail .now span {
    font-size: 28px;
    font-weight: 700;
    color: #d33d27;
}

.accept-detail .p-before {
    padding-left: 8px;
    color: #ad7239;
    text-decoration: line-through;
}

.accept-detail .u-btn.apply {
    width: 100px;
    height: 100px;
    margin: 0 0 0 50px;
    background-image: url(~@/assets/images/btn-accept-apply.png);
}

.accept-detail .discount-detail {
    width: 711px;
    height: 360px;
    margin: 0 auto;
    padding-top: 35px;
    background-image: url(~@/assets/images/bg-ac-dis.png);
    box-sizing: border-box;
}

.accept-detail .discount-detail .title {
    width: 510px;
    height: 50px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/title-ac-dis.png);
}
</style>


// WEBPACK FOOTER //
// src/views/help.vue